<template>
  <a-config-provider
          :theme="{
      /*algorithm: theme.darkAlgorithm,*/
       token: {
        colorPrimary: 'cyan',
      },
    }"
  >
    <router-view></router-view>
  </a-config-provider>
</template>

<script>
import { theme } from 'ant-design-vue';

export default {

  name: 'App',
  components: {},
  data(){
      return{
          theme:theme
      }
  }
}
</script>

<style>
</style>
